import React from 'react';
import TagId from '~/constants/TagId';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';
import DeliveryTruckIcon from '~/icons/DeliveryTruckIcon';
import NewPriceIcon from '~/icons/NewPriceIcon';
import PlugIcon from '~/icons/PlugIcon';
import TagIcon from '~/icons/TagIcon';

const getSubText = (
  key: string
): {
  subText: string;
  Icon: React.SVGProps<SVGSVGElement>;
  dataQa?: string;
} => {
  switch (key) {
    case 'isFreeDelivery':
      return {
        Icon: <DeliveryTruckIcon />,
        subText: 'Vehicles without shipping fees and available sooner.',
        dataQa: 'free-shipping-copy'
      };
    case TagId.GreatDeal.toString():
      return {
        Icon: <TagIcon />,
        subText:
          'Vehicles priced lower than the Kelley Blue Book® Typical Listing Price.',
        dataQa: 'great-deal-copy'
      };
    case TagId.PriceDrop.toString():
      return {
        Icon: <NewPriceIcon className="blue" />,
        subText:
          'We are always repricing our inventory to make room for new vehicles. Don’t miss out!',
        dataQa: 'price-drop-copy'
      };
    case TagId.EVCredit.toString():
      return {
        Icon: <PlugIcon />,
        subText:
          'Vehicles that may qualify for the Previously-Owned Clean Vehicle tax credit.',
        dataQa: 'ev-tax-credit-copy'
      };
    default:
      return { Icon: <div />, subText: '' };
  }
};

type LabelProps = {
  count: number;
  displayName?: string;
  hideCount?: boolean;
  labelKey: string;
};

const GreatDealsLabel = ({
  count = -1,
  displayName = '',
  hideCount,
  labelKey
}: LabelProps) => {
  const showCount =
    useCheckExperimentBucket('srch-impossible-facets', 'experiment') &&
    !hideCount;
  const { Icon, subText, dataQa } = getSubText(labelKey);

  return (
    <div className="flex flex-col gap-[6px]">
      <div className="flex font-bold gap-8 items-center leading-[20px] text-[16px]">
        <span>{displayName}</span>
        {Icon}{' '}
        {showCount && count >= 0 ? (
          <span className="!font-bold self-end text-grey-3 tl-body-xs">
            ({count.toLocaleString()})
          </span>
        ) : null}
      </div>
      <div className="text-grey-5 tl-body-s" data-qa={dataQa}>
        {subText}
      </div>
    </div>
  );
};

export default GreatDealsLabel;
